/* jslint browser: true */
import React, { Component } from 'react';
import PropTypes            from 'prop-types';

/**
 * Titre du bloc de type programme
 */
class ProgramBlockTitle extends Component {

    constructor(props){
        super(props);
    }

    render(){
        return (<div>
            <span style={{color:"#FFF"}}>{this.props.titre}</span>
                </div>);
    }
}

ProgramBlockTitle.propTypes = { semaine: PropTypes.number };

export default ProgramBlockTitle;



// WEBPACK FOOTER //
// ./src/components/annexes/ProgramBlockTitle.js